import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "@/components/Navigation";
import LandingPage from "@/pages/LandingPage";
import TestPage from "@/pages/TestPage";
import DashboardPage from "@/pages/DashboardPage";
import CertificatePage from "@/pages/CertificatePage";
import CertificatesIndexPage from "@/pages/CertificatesIndexPage";

function App() {
  return (
    <div className="App min-h-screen bg-zinc-950 text-white">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/certificate" element={<CertificatesIndexPage />} />
          <Route path="/certificate/:id" element={<CertificatePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
